<template>
  <div data-test-id="gift-card-and-credit-button">
    <template v-if="isButton">
      <q-btn
        v-bind="$attrs"
        class="q-pb-xs q-py-sm full-width"
        @click="$emit('click-button')"
      >
        <slot name="buttonLabel" />
      </q-btn>
      <div
        class="col text-subtitle2 text-center text-accent"
        style="border-radius: 0 0 4px 4px; border-bottom: 1px solid; border-right: 1px solid; border-left: 1px solid;"
      >
        <slot name="buttonSubtitle" />
      </div>
    </template>
    <q-banner
      v-else
      inline-actions
      class="text-body1 bg-responsive-white"
    >
      <div class="text-responsive">
        <slot name="toggleButtonLabel" />
      </div>

      <div class="text-responsive-grey-7">
        <slot name="toggleButtonSubtitle" />
      </div>
      <template #action>
        <q-toggle
          v-model="modelValue"
          checked-icon="check"
          color="positive"
          unchecked-icon="clear"
          :disable="disable"
          @update:model-value="emitValues"
        />
      </template>
    </q-banner>
  </div>
</template>
<script>

export default {
  name: 'GiftCardAndCreditButton',
  props: {
    value: {
      type: Boolean,
      required: false,
      default: false
    },
    isButton: {
      type: Boolean,
      required: false,
      default: false
    },
    disable: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value', 'click-button', 'click-toggle-button'],
  data () {
    return {
      modelValue: this.value
    }
  },
  watch: {
    modelValue () {
      this.emitValues(this.modelValue)
    },
    value () {
      this.modelValue = this.value
    }
  },
  methods: {
    emitValues (value) {
      // Emit the updated value first
      this.$emit('update:model-value', value)

      // Then emit the click event
      this.$emit('click-toggle-button')
    }
  }
}
</script>
